module.exports = __webpack_public_path__ + "static/media/georgie.a59265de.png";